

import { isEmbedData, renderProjectDetail } from "./fjk.project.detail";

const indevidual_uidlabel = "uid";
const indevidual_filename = "detail.html";

const base_path = "/projects/";
const jsondata = [
  "/assets/data/pjdata_public.json",
  "/assets/data/pjdata_welfare.json",
  "/assets/data/pjdata_education.json",
  "/assets/data/pjdata_commercial.json",
  "/assets/data/pjdata_condominium.json",
  "/assets/data/pjdata_office.json",
  "/assets/data/pjdata_other.json",
  "/assets/data/pjdata_house.json",
];

// URLのパラメータを分解
export function urlParmsSeparate(str) {
  let test_str = "?page=2&uid=50_39_88";

  let result_array = str.replace("?", "").split("&");

  let page_parmas = {
    params: result_array,
    uid: "",
    list_page: "",
  };
  result_array.forEach((elm) => {
    const elm_array = elm.split("=");
    if (elm_array[0] === "page") {
      page_parmas.list_page = parseInt(elm_array[1], 10);
    }
    if (elm_array[0] === indevidual_uidlabel ) {
      page_parmas.uid = elm_array[1];
    }
  });

  console.log(page_parmas);
  return page_parmas;
}

// URLから必要な情報を生成
export function getPageParamas() {
  // console.log(location);
  let page_params = urlParmsSeparate(location.search);
  let page_path = location.pathname.replace(base_path, "").split("/");
  let page_no_parm = parseInt(location.search.replace("?page=", ""), 10);
  let category_path = page_path[0];
  let project_filename = "";
  let project_id = page_params.uid;
  if (page_path[1]) {
    // console.log(page_path)
    project_filename = page_path[1];
    category_path = page_path[0];
  } else {
    category_path = page_path[0];
  }

  if (!page_no_parm) {
    page_no_parm = 1;
  }

  let params = {
    page_no: page_no_parm,
    category: category_path,
    project_filename: project_filename,
    project_id: project_id,
  };
  console.log(params);

  return params;
}


export function loadJsonData(jsonFilePath, async_mode) {
  // async_mode
  // true  : default -> async
  // false : -> sync
  const path = jsonFilePath;

  let sync_flg = true;
  if (!async_mode) {
    sync_flg = false;
  } else if (async_mode === true) {
    sync_flg = true;
  } else {
    sync_flg = true;
  }

  return $.ajax({
    type: "GET",
    url: path,
    async: sync_flg,
  });
}


export function dataLoad(data, page_category) {
  // 事例の整理
  let cases = {
    sets: [],
    ids: [],
    html_allitems: [],
    allitems: [],
  };

  for (let i = 0; i < data.length; i++) {
    const elm = data[i];

    // カテゴリのindex を作成
    let category_index = elm.category_id.replace(/cat_/g, "");
    let loop_index_no = parseInt(category_index, 10) - 1;

    //
    let check = cases.ids.find((value) => value === elm.category_id);

    if (!check) {
      let category_set = {
        category_index: category_index,
        category_id: elm.category_id,
        category_code: elm.category_code,
        category_label: elm.category_label,
        category_items: [],
      };
      // category_set.category_items.push(elm);
      cases.sets.push(category_set);
      cases.ids.push(elm.category_id);
    }

    // 一覧のコンテナを作成

    // cases.items.push(elm);
    cases.allitems.push(elm);
    cases.html_allitems.push(`
<div>
<div class="img"><img src="https://placehold.jp/450x450.png" alt="${elm.name}" /></div>
<div class="text"><p>${elm.name}</p></div>
<div class="footer"><span class="category">${elm.category_label}</span><span class="place">${elm.place}</span><span class="year">${elm.year}</span></div>
</div>
`);

    // カテゴリをソート
    cases.sets.sort(function (a, b) {
      if (a.category_index < b.category_index) return -1;
      if (a.category_index > b.category_index) return 1;
      return 0;
    });
  }
  return cases;
}

// 全てのデータを一つのobject に格納する
export function getAllData(array) {
  let result = {
    alldata: [],
    categories: {},
  };

  array.forEach((elm) => {
    loadJsonData(elm, false)
      .done(function (res) {
        // category_code を取得
        const category_code = res[0].category_code;
        // console.log(elm)
        // alldata に concat で既存の配列と結合 alldata を単一の配列として扱うため
        result.alldata = result.alldata.concat(res);
        // categories の下に category_code を key にして value にカテゴリごとの配列を突っ込む
        result.categories[category_code] = res;
      })
      .fail(function (result) {
        console.log("error : ", statusText);
        console.log("result : ", result);
      });
  });

  // console.log(result);
  return result;
}


// 年でソートする
export function sortYear(data) {
  let sorted_data = data;

  sorted_data.sort(function (a, b) {
    // a < b 降順 (数字が大きい方が先)
    // a > b 昇順 (数字が小さい方が先)
    if (a.year < b.year) {
      return 1;
    } else {
      return -1;
    }
  });

  return sorted_data;
}

// カードを生成
export function build_card(data, count) {
  let surplus_class = "";
  if (count) {
    surplus_class = " item_surplus";
  }
  let tags = {
    year: "",
    place: "",
  };
  if (data.year) {
    tags.year = `<span class="year">${data.year}年</span>`;
  }
  if (data.place != "") {
    tags.place = `<span class="place">${data.place}</span>`;
  }
  // let html = `
  //   <div class="prj__card prj__count_${data.id}${surplus_class}" data-uid="${data.uid}">
  // <div class="img"><img src="https://placehold.jp/450x450.png" alt="${data.name}" /></div>
  // <div class="text"><p>${data.name}</p></div>
  // <div class="footer"><span class="category">${data.category_label}</span>${tags.place}${tags.year}</div>
  // </div>`;
  let prj_url_path = data.path.replace(
    "https://www.fujikigumi.co.jp/temp_projects/",
    "/projects/"
  );
  let html = `<a href="${prj_url_path}" class="prj__card prj__count_${data.id}${surplus_class}" data-uid="${
    data.uid
  }">
  <div>
<div class="img"><img src="${data.photos.main}" /></div>
<div class="text"><p>${data.name}</p></div>
<div class="footer"><span class="category">${data.category_label}</span>${
    tags.place
  }${tags.year}</div>

</div></a>`;
  return html;
}

export function buildCards(data, page_params, limit_no, offset_no) {
  let output_items = "";

  let cards_html = "";

  let limit = limit_no;
  let offset = offset_no;

  console.log(limit_no, offset_no);

  if (page_params.page_no === 1) {
    limit = limit_no;
    offset = offset_no;
  } else {
    limit = limit_no * page_params.page_no;
    offset = limit_no * (page_params.page_no - 1);
  }

  let build_set = [];
  data.forEach((element) => {
    if (page_params.category === element.category_code) {
      build_set.push(element);
    } else if (page_params.category === "") {
      build_set.push(element);
    }
  });

  if (build_set.length < limit) {
    limit = build_set.length;
  }
  for (let i = offset; i < limit; i++) {
    let case_count = false;
    let ic = i + 1;
    const element = build_set[i];
    // console.log(page_params.category, element.category_code);
    

    if (ic === limit && ic % 3 !== 0) {
      case_count = true;
    }

    // console.log(ic,limit, case_count)


    // 要注意！先にstatus をチェックしてからlimit の値で回すように変更する
    if (element.status){
      cards_html += build_card(element, case_count);
    }
  }

  return cards_html;
}

export function renderCatList(data, page_params) {
  // console.log(data)

  let current_category = page_params.category;

  let selectorListContainer = $(".projects__nav");
  let current_category_class = "";

  let listHtml = `<ul class="prj__category_list">`;
  // 全て事例を表示させるためのリンクを挿入
  if (page_params.category === "") {
    current_category_class = " prj__category_listitem-isActive";
  }
  listHtml += `<li class="cat_0 prj__category_listitem prj__category_listitem-isAll${current_category_class}"><a href="${base_path}">すべて</a></li>`;

  let categories = Object.keys(data);
  // console.log(categories)

  for (let i = 0; i < categories.length; i++) {
    const category_array = data[categories[i]];
    const elm = category_array[0];

    current_category_class = "";

    if (elm.category_code === current_category) {
      current_category_class = " prj__category_listitem-isActive";
    }
    listHtml += `<li class="prj__category_listitem${current_category_class}"><a href="${base_path}${elm.category_code}/">${elm.category_label}</a></li>`;
  }
  listHtml += "</ul>";

  $(selectorListContainer).append(listHtml);
}

export function renderPager(data, page_params) {
  let current_page = page_params.page_no;
  // console.log("page :" + current_page);

  const clean_data = statusCheck(data);

  let selectorPagerContainer = $(".pager");
  let current_category_data = [];

  for (let i = 0; i < clean_data.length; i++) {
    const elm = clean_data[i];

    if (page_params.category === elm.category_code) {
      current_category_data.push(elm);
    } else if (page_params.category === "") {
      current_category_data.push(elm);
    }
  }

  let per_page_items = 12;
  let alldata_length = current_category_data.length;
  let pager_numbers = alldata_length / per_page_items;

  let pager_html = `<ul class="pager__list">`;

  // console.log(current_category_data.length);

  for (let i = 0; i < pager_numbers; i++) {
    const elm = pager_numbers[i];
    const pager_no = i + 1;
    let current_page_class = "";
    if (pager_no === current_page) {
      current_page_class = " pager__listitem-isActive";
    }
    pager_html += `<li class="pager__listitem pager__${pager_no}${current_page_class}"><a href="?page=${pager_no}">${pager_no}</a></li>`;
    // console.log(pager_no)
  }
  pager_html += `</ul>`;
  $(selectorPagerContainer).html(pager_html);
  // console.log(pager_html);
}

// 主に一覧ページでの物件を生成
export function renderProjects(data, page_params) {
  let selectorProjectsContainer = $(".prj__cards_list");

  let limit = 12;
  let offset = 0;

  const clean_data = statusCheck(data);

  let cards_html = buildCards(clean_data, page_params, limit, offset);

  $(selectorProjectsContainer).append(cards_html);
}

// カテゴリから関連物件を生成
export function renderRelatedProjects(data, page_params) {
  let selectorProjectRelatedContainer = $(".project__related");
  let limit = 6;
  let offset = 0;

 const clean_data = statusCheck(data);
  let cards_html = buildCards(clean_data, page_params, limit, offset);

  $(selectorProjectRelatedContainer).append(cards_html);
}

export function statusCheck(data){

  let clean_data = []

  data.forEach(elm => {
    if(elm.status){
      clean_data.push(elm);
    }
  });

  return clean_data;
}


export function projectsPageFunctions(){

// JSON のデータを取得
const alldatas = getAllData(jsondata);
// URLからパラメータをもとに必要な情報を取得
const pageparamas = getPageParamas();


// カテゴリのナビゲーションを生成
renderCatList(alldatas.categories, pageparamas);
// ソートされた 物件一覧を生成
renderProjects(sortYear(alldatas.alldata), pageparamas);
// ページ送りを生成
renderPager(sortYear(alldatas.alldata), pageparamas);

let project_id = pageparamas.project_id;

if (project_id !== "") {
  // 個別事例のレンダリング
  // カテゴリの年数が新しいものを関連物件として表示
  
  // 物件の細かな部分を表示
  let target_uid = project_id;
  const target_item = alldatas.alldata.find((v) => v.uid === target_uid);
  renderProjectDetail(target_item);
}

if(isEmbedData().flag){
  renderRelatedProjects(sortYear(alldatas.alldata), pageparamas);

  // 物件の細かな部分を表示
  let target_uid = isEmbedData().data.projectid;
  // console.log(isEmbedData().data.projectid);
  const target_item = alldatas.alldata.find((v) => v.uid === target_uid);

  renderProjectDetail(target_item);
}



}
// console.log("fjk.projects.js");